// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3wxa_","switchMark":"styles_switchMark__1Fcew"};